import { ReactComponent as SvgLogo } from './assets/logo.svg'
import Contact from './contact.jsx'
import Fade from './utils/fade.jsx'
import { Link } from 'react-router-dom'

export default function Home() {
  return (
    <>
      <div className='section about'>
        <Fade>
          <div className='img-about'>
            <SvgLogo className='svg-logo' />
          </div>
        </Fade>
        <div className='text-about'>
          <Fade>
            <h1>
              Hi, I'm Victor Mustin, a full-stack engineer with 4+ years of
              experience building products from zero to production.
            </h1>
            <h1>
              Currently Member of Technical Staff at Enobase (HX26).
            </h1>
            <h1>For inquiries and availability : victormustin@gmail.com </h1>
          </Fade>
        </div>
      </div>
      <div className='section'>
        <div className='exp-wrapper'>
          <Fade delay={0.4}>
            <div className='exp-title'>Member of Technical Staff</div>
            <div className='exp-subtitle'>
              ENOBASE (HX26) (enobase.com) — May 2026 - present
            </div>
            <div className='separator' />
          </Fade>
          <Fade delay={0.4}>
            <ul className='smaller'>
              <li>
                <p>
                  Enobase helps companies run their operations in one
                  tailor-made system, replacing fragmented tools with a
                  composable business application platform.
                </p>
              </li>
              <li>
                <p>
                  As a Member of Technical Staff, I design and build product
                  features that shape the core platform.
                </p>
              </li>
            </ul>
            <div className='a-wrapper'>
              <a
                className='exp-link'
                href='https://enobase.com/'
                target='_blank'
                rel='noopener noreferrer'
              >
                To Website
              </a>
            </div>
          </Fade>
        </div>

        <div className='exp-wrapper'>
          <Fade delay={0.5}>
            <div className='exp-title'>Founder & Full-Stack Engineer</div>
            <div className='exp-subtitle'>
              SOLO VENTURE — March 2026 - May 2026
            </div>
            <div className='separator' />
          </Fade>
          <Fade delay={0.5}>
            <ul className='smaller'>
              <li>
                <p>
                  Building a self-serve AI platform that replaces Odoo
                  implementation agencies: non-technical business owners
                  describe their needs, an agent implements, tests, and deploys
                  a fully customized Odoo ERP.
                </p>
              </li>
              <li>
                <p>
                  Stack: Next.js, Vercel AI SDK, PostgreSQL, Odoo (Python,
                  XML-RPC), Docker, Caddy, AWS EC2, GitHub Actions
                </p>
              </li>
            </ul>
          </Fade>
        </div>

        <div className='exp-wrapper'>
          <Fade delay={0.6}>
            <div className='exp-title'>Full-Stack Engineer</div>
            <div className='exp-subtitle'>
              MAYA (mayatravel.ai) — April 2025 - May 2026
            </div>
            <div className='separator' />
          </Fade>
          <Fade delay={0.6}>
            <ul className='smaller'>
              <li>
                <p>
                  Building and shipping AI agents that automate customer support
                  for travel companies via web chat, email, WhatsApp, and social
                  channels — handling ~4,500 requests/day.
                </p>
              </li>
              <li>
                <p>
                  Built a recursive self-improving system: clients review past
                  conversations, provide feedback, and agents improve through
                  automated eval pipelines and bulk testing.
                </p>
              </li>
              <li>
                <p>
                  Refactored a simple RAG setup into a modular multi-tool agent
                  infrastructure, making agents easy to configure, observe and
                  extend for non-technical team members.
                </p>
              </li>
              <li>
                <p>
                  Sole owner of the "Internal Agents" feature: built 25+ custom
                  agents for 10+ companies, deeply integrated into their
                  internal processes and softwares, including an interface where
                  users and agents co-edit documents together.
                </p>
              </li>
              <li>
                <p>
                  Stack: React, NestJS, Python, FastAPI, PostgreSQL, LangChain
                  ecosystem, Vercel AI SDK, Azure, Kubernetes, Docker, S3
                </p>
              </li>
            </ul>
            <div className='a-wrapper'>
              <a
                className='exp-link'
                href='https://mayatravel.ai/'
                target='_blank'
                rel='noopener noreferrer'
              >
                To Website
              </a>
            </div>
          </Fade>
        </div>

        <div className='exp-wrapper'>
          <Fade delay={0.7}>
            <div className='exp-title'>Full-Stack Engineer</div>
            <div className='exp-subtitle'>FREELANCE — 2023 - April 2025</div>
            <div className='separator' />
          </Fade>
          <Fade delay={0.7}>
            <ul className='smaller'>
              <li>
                <p>
                  Startups: Collaborated on multiple projects from pre-launch
                  MVPs to large-scale products, handling frontend, backend,
                  infrastructure, design, and AI across the board.
                </p>
              </li>
              <li>
                <p>
                  3DAIstudio.com — Refactored the full app to Next.js App Router
                  (3.5x faster loads). Built an AI-powered 3D editor for texture
                  painting and generation on 3D objects. Migrated backend from
                  serverless to self-hosted EC2.
                </p>
              </li>
              <li>
                <p>
                  Office Broner (ob.services) — Built an award-winning GSAP
                  website for a production agency
                  (specialproduction.agency). Content creation and AI tools for
                  creative industry clients.
                </p>
              </li>
            </ul>
          </Fade>
        </div>

        <div className='exp-wrapper'>
          <Fade delay={0.8}>
            <div className='exp-title'>Founder, Full-Stack Engineer</div>
            <div className='exp-subtitle'>AIPACKSHOT — 2025</div>
            <div className='separator' />
          </Fade>
          <Fade delay={0.8}>
            <ul className='smaller'>
              <li>
                <p>
                  Built an AI-powered tool for creating studio-quality product
                  photos for e-commerce and marketing. Solo founder handling
                  full-stack development, AI development, distribution,
                  marketing, and customer support.
                </p>
              </li>
            </ul>
            <div className='a-wrapper'>
              <a
                className='exp-link'
                href='https://aipackshot.com/'
                target='_blank'
                rel='noopener noreferrer'
              >
                To Website
              </a>
            </div>
          </Fade>
        </div>

        <div className='exp-wrapper'>
          <Fade delay={0.9}>
            <div className='exp-title'>Co-Founder, Full-Stack Engineer</div>
            <div className='exp-subtitle'>NEVERSCENE — 2024</div>
            <div className='separator' />
          </Fade>
          <Fade delay={0.9}>
            <ul className='smaller'>
              <li>
                <p>
                  Developed an AI-powered tool for interior designers to
                  generate inspiration and share content. In charge of
                  full-stack and AI development.
                </p>
              </li>
            </ul>
            <div className='a-wrapper'>
              <a
                className='exp-link'
                href='https://www.neverscene.ai/'
                target='_blank'
                rel='noopener noreferrer'
              >
                To Website
              </a>
            </div>
          </Fade>
        </div>

        <div className='exp-wrapper'>
          <Fade delay={1}>
            <div className='exp-title'>
              Full-Stack Engineer & 3D Interaction Designer
            </div>
            <div className='exp-subtitle'>VICEVERSA — 2022</div>
            <div className='separator' />
          </Fade>
          <Fade delay={1}>
            <ul className='smaller'>
              <li>
                <p>
                  Developed interactive 3D experiences for luxury e-commerce
                  (LVMH, Givenchy, Sephora).
                </p>
              </li>
              <li>
                <p>
                  Created intuitive tools for clients to edit 3D assets with
                  high visual fidelity.
                </p>
              </li>
              <li>
                <p>
                  Built and maintained RESTful APIs for seamless integration
                  between front-end experiences and back-end systems.
                </p>
              </li>
              <li>
                <p>
                  Implemented database architecture and server-side logic to
                  support complex 3D processing.
                </p>
              </li>
            </ul>
          </Fade>
          <Fade delay={1.1}>
            <div className='a-wrapper'>
              <Link className='exp-link' to='/demos-1'>
                View Demos
              </Link>
            </div>
          </Fade>
        </div>

        <div className='exp-wrapper'>
          <Fade delay={1.2}>
            <div className='exp-title'>
              3D Studio Lead (Photogrammetry & Modeling)
            </div>
            <div className='exp-subtitle'>VICEVERSA — 2021-2022</div>
            <div className='separator' />
          </Fade>
          <Fade delay={1.2}>
            <ul className='smaller'>
              <li>
                <p>
                  Built and optimized a AAA 3D pipeline for luxury fashion
                  brands (Chanel, Jacquemus, Alaïa).
                </p>
              </li>
              <li>
                <p>
                  Led a team of 6 in-house artists and 4 outsourcing studios.
                </p>
              </li>
            </ul>
          </Fade>
          <Fade delay={1.3}>
            <div className='a-wrapper'>
              <Link className='exp-link' to='/3Dmodels'>
                View 3D models
              </Link>
            </div>

            <div className='a-wrapper'>
              <a
                className='exp-link'
                href='https://www.lemonde.fr/m-styles/article/2022/02/19/la-mode-se-pique-de-clonage-virtuel_6114374_4497319.html'
                target='_blank'
                rel='noopener noreferrer'
              >
                Read press from Le Monde (FR)
              </a>
            </div>
          </Fade>
        </div>

        <div className='exp-wrapper'>
          <Fade delay={1.4}>
            <div className='exp-title'>Augmented Reality Designer</div>
            <div className='exp-subtitle'>BARNEYSTUDIOS — 2020-2021</div>
            <div className='separator' />
          </Fade>
          <Fade delay={1.4}>
            <ul className='smaller'>
              <li>
                <p>
                  Designed AR experiences and virtual try-ons for brands like
                  Netflix, Adidas, Givenchy.
                </p>
              </li>
            </ul>
          </Fade>
        </div>

        <div className='exp-wrapper'>
          <Fade delay={1.5}>
            <div className='exp-title'>Augmented Reality Designer</div>
            <div className='exp-subtitle'>FREELANCE — 2019-2021</div>
            <div className='separator' />
          </Fade>
          <Fade delay={1.5}>
            <ul className='smaller'>
              <li>
                <p>
                  Created AR filters and interactive experiences for A24, Prime
                  Video, YSL, Calvin Klein.
                </p>
              </li>
            </ul>
          </Fade>
        </div>

        <div className='exp-wrapper'>
          <Fade delay={1.6}>
            <div className='exp-title'>Skills</div>
            <div className='separator' />
          </Fade>
          <Fade delay={1.6}>
            <ul className='smaller'>
              <li>
                <p>
                  Front-end: React, Next.js, Vue, Nuxt, Tailwind, Three.js,
                  WebGL, GSAP
                </p>
              </li>
              <li>
                <p>
                  Back-end: Node.js, NestJS, Express, Python, FastAPI, REST APIs
                </p>
              </li>
              <li>
                <p>
                  AI: LangChain, Vercel AI SDK, OpenAI/Claude/Gemini APIs, agent
                  orchestration, eval pipelines, ComfyUI
                </p>
              </li>
              <li>
                <p>
                  Cloud/DevOps: AWS (S3, Lambda, EC2, SSM, SES), Azure,
                  Kubernetes, Docker, GitHub Actions, Caddy, Sentry
                </p>
              </li>
              <li>
                <p>Databases: PostgreSQL, Drizzle ORM, MySQL</p>
              </li>
              <li>
                <p>Payments: Stripe</p>
              </li>
              <li>
                <p>3D: Blender, Substance Suite, ZBrush, CLO3D, UE5</p>
              </li>
            </ul>
          </Fade>
        </div>

        <div className='exp-wrapper'>
          <Fade delay={1.7}>
            <div className='exp-title'>Education</div>
            <div className='separator' />
          </Fade>
          <Fade delay={1.7}>
            <ul className='smaller'>
              <li>
                <p>
                  Film Directing & Screenwriting, Institut des Arts de Diffusion
                  (2019 - 2020)
                </p>
              </li>
              <li>
                <p>Civil Engineering, EPL (2016 - 2018)</p>
              </li>
              <li>
                <p>Belgian Math Olympiad finalist (2014, 2015)</p>
              </li>
            </ul>
          </Fade>
        </div>

        <div className='footer' />
        {/* <Contact/> */}
      </div>
    </>
  )
}
